import { StripeEnv } from '../../util/enums';

export type FinancialAccountProcessor = 'STRIPE' | 'UNIT';

export interface OrgNode {
  id: string;
  name: string;
  fields: {
    country: string;
    city: string;
    zip_code: string;
    phone: string;
    state_code: string;
    street?: string;
    ein_number?: string;
    description?: string;
    url?: string;
    legal_name?: string;
  };
  parent?: Omit<OrgNode, 'parent'>;
  type: GraphqlTypeName;
}

export type OrgType =
  | 'BOOSTER'
  | 'CLUB'
  | 'BUSINESS'
  | 'DISTRICT'
  | 'FOUNDATION'
  | 'PROGRAM'
  | 'PTA'
  | 'SCHOOL'
  | 'TEAM';

export interface FinancialAccountNode {
  orgId?: string;
  orgName?: string;
  kybId?: string;
  finAcctId?: string | null;
  processor?: FinancialAccountProcessor;
  status?: FinancialNodeStatus;
  acctId?: string;
  applicationId?: string;
  customerId?: string;
  createdAt?: Date;
  updatedAt?: Date;
  orgEin?: string;
  orgType?: OrgType;
  stripeEnv?: StripeEnv;
  paymentMethodId?: string;
}

export interface CreateFinancialAccountParams {
  kybId: string;
  orgId: string;
  processor: FinancialAccountProcessor;
  acctId?: string;
  applicationId?: string;
  customerId?: string;
  status?: FinancialNodeStatus;
  stripeEnv: StripeEnv;
}

export interface FinancialAccountUserAssociateParams {
  finAcctId: string;
  userId: string;
  isBeneficialOwner?: boolean;
  isContact?: boolean;
  isPrincipal?: boolean;
  isRepresentative?: boolean;
  kycId?: string;
  personId?: string;
}

export interface FinancialAccountUser {
  processor: FinancialAccountProcessor;
  kycId: string;
  personId: string;
  userId?: string;
  acctId?: string;
  isRepresentative?: boolean;
  finAcctId?: string;
}

export interface UpdateFinancialAccountParams {
  orgId?: string;
  finAcctId: string;
  kybId?: string;
  status?: FinancialNodeStatus;
  acctId?: string;
  applicationId?: string;
  customerId?: string;
  paymentMethodId?: string;
}

export interface FinancialNodeProperties {
  finAcctId: string;
  orgId: string;
  kybId: string;
  kycId: string;
  processor: FinancialAccountProcessor;
  status: FinancialNodeStatus;
  acctId: string;
  applicationId: string;
  customerId: string;
  userId: string;
  internal: boolean;
  type: string[];
  isPrincipal: boolean;
  isRepresentative: boolean;
  isBeneficialOwner: boolean;
  isContact: boolean;
}

export interface MutationResponse {
  success: boolean;
  properties: FinancialNodeProperties;
  errors: MutationError[];
}

interface MutationError {
  message: string;
  type: string;
}

export enum FinancialNodeStatus {
  ACTION_REQUIRED = 'ACTION_REQUIRED',
  ACTIVE = 'ACTIVE',
  APPROVED = 'APPROVED',
  AWAITING_REAPPROVAL = 'AWAITING_REAPPROVAL',
  DECLINED = 'DECLINED',
  PENDING = 'PENDING',
  TERMINATED = 'TERMINATED',
  UNDER_REVIEW = 'UNDER_REVIEW',
}

export type GraphqlTypeName =
  | 'Booster'
  | 'Club'
  | 'District'
  | 'Program'
  | 'School'
  | 'Foundation'
  | 'PTA';

export const AUXILIARY_ORG_TYPES: OrgType[] = [
  'BOOSTER',
  'CLUB',
  'FOUNDATION',
  'PTA',
];
